export { default as component } from "../../../../src/routes/[prefix]/(feature)/faq/+page.svelte";